import store from '../index';
import { BaseQueryApi, FetchArgs, createApi, fetchBaseQuery } from '@reduxjs/toolkit/query';
import { login, logout } from '../slices/auth.slice';
import { refreshTokens } from '@/utils';

 const getToken = (state: any, key: 'access_token' | 'refresh_token') => {
	const { user } = state.auth;
	return user && user[key];
};

const baseQuery = fetchBaseQuery({
	baseUrl: process.env.REACT_APP_BASE_URL,
	prepareHeaders: (headers, { getState, endpoint }: any) => {
		const token = getToken(getState(), 'access_token');
		const refreshToken = getToken(getState(), 'refresh_token');
		if (token) {
			headers.set('Authorization', `Bearer ${endpoint.includes('refresh') ? refreshToken : token}`);
		}
		return headers;
	},
});

 const generalBaseQuery = async (args: FetchArgs, api: BaseQueryApi, extraOptions: any = {}) => {
	let result = await baseQuery(args, api, extraOptions);
	if (result.error && result.error.status === 401) {
		try {
			const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')!) : null;
			if (!user) throw new Error();
			const refreshToken = user.refresh_token;
			if (refreshToken) {
				const newTokens = await refreshTokens(refreshToken, user.role === 'Usher' ? 'ushers' : 'admins');
				api.dispatch(login(newTokens));
				extraOptions.headers = {
					...extraOptions.headers,
					Authorization: `Bearer ${newTokens.access_token}`,
				};
				result = await baseQuery(args, api, extraOptions);
			}
		} catch (error) {
			api.dispatch(logout());
		}
	}

	return result;
};

export default generalBaseQuery
 